import React, { useContext, useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useContextInfo } from '../../context/ContextInfo';
import { fetchConToken } from '../../api/fetch';

const ModCanclGlobal = ({ show, onClose, callBk, data }) => {
    const { setResp } = useContextInfo();
    const [validated, setValidated] = useState(false);

    const [loading, setLoading] = useState(false);
    const [motive, setMotivo] = useState('01');
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        setLoading(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            let res = await fetchConToken(
                `global/cancel`,
                {
                    motive,
                    id: data.id,
                    fcId: data.idf,
                },
                'PUT'
            );
            setResp(res);
            setLoading(false);
            if (res.ok) {
                callBk();
                onClose();
            }
        }
    };
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Cancelar factura</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate validated={validated} onSubmit={onSubmit}>
                                        {' '}
                                        <p>
                                            Cancelar factura con numero de folio <b>{data.folio}</b>{' '}
                                        </p>
                                        <Form.Group className="mb-3" controlId="validationCustom022">
                                            <Form.Label> Motivo de cancelación</Form.Label>
                                            <Form.Select
                                                value={motive}
                                                name="tipo"
                                                required
                                                onChange={(e) => setMotivo(e.target.value)}>
                                                <option value="01">Comprobante emitido con errores con relación</option>
                                                <option value="02">
                                                    Comprobante emitido con errores sin relación.
                                                </option>
                                                <option value="03">No se llevó a cabo la operación.</option>
                                                <option value="04">
                                                    Operación nominativa relacionada en la factura global.
                                                </option>
                                            </Form.Select>
                                        </Form.Group>
                                        {loading ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Cancelado...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Cancelar factura</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModCanclGlobal;
